/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S7_P2Inputs */

const tr_kullanim_s7_p2 = /** @type {(inputs: Kullanim_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kullanıcı, Platform kullanım süresi ile sınırlı, dünya çapında, devredilemez ve münhasır olmayan bir kullanım lisansına sahiptir.`)
};

const en_kullanim_s7_p2 = /** @type {(inputs: Kullanim_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The User holds a worldwide, non-transferable and non-exclusive licence of use, limited to the period of Platform use.`)
};

const de_kullanim_s7_p2 = /** @type {(inputs: Kullanim_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Nutzer verfügt über eine auf die Dauer der Plattformnutzung beschränkte, weltweite, nicht übertragbare und nicht ausschließliche Nutzungslizenz.`)
};

const ru_kullanim_s7_p2 = /** @type {(inputs: Kullanim_S7_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользователь обладает всемирной, непередаваемой и неисключительной лицензией на использование, ограниченной сроком пользования Платформой.`)
};

/**
* | output |
* | --- |
* | "The User holds a worldwide, non-transferable and non-exclusive licence of use, limited to the period of Platform use." |
*
* @param {Kullanim_S7_P2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s7_p2 = /** @type {((inputs?: Kullanim_S7_P2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S7_P2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s7_p2(inputs)
	if (locale === "de") return de_kullanim_s7_p2(inputs)
	if (locale === "ru") return ru_kullanim_s7_p2(inputs)
	return tr_kullanim_s7_p2(inputs)
});